<template>
  <div>
    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Add Job Title"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          @click="openNewTypesForm"
        />
      </template>
      <template slot="right">
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText v-model="filters['global']" placeholder="Global Search" />
        </span>
      </template>
    </Toolbar>
    <DataTable
      :value="JobTitles"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="contactId"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Related Accounts"
    >
      <template #header>
        <div class="table-header">Related Job Titles</div>
      </template>

      <template #empty> No Related Job Titles Accounts found! </template>
      <template #loading>
        Loading Related Job Titles. Please wait.
      </template>
      <Column field="id" header="Id" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.id ? slotProps.data.id : "" }}
        </template>
      </Column>
      <Column field="jobTitleCode" header="Display Order" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.jobTitleCode ? slotProps.data.jobTitleCode : "" }}
        </template>
      </Column>
      <Column field="jobTitleDesc" header="Description" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.jobTitleDesc ? slotProps.data.jobTitleDesc : "" }}
        </template>
      </Column>
      <Column field="active" header="Active" :sortable="true">
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 10em;">
        <template #body="slotProps">
          <div :style="{ position: 'relative' }">
            <SplitButton
              label="Edit"
              icon="pi pi-pencil"
              class="p-button-success p-mb-2"
              @click="editJobTitles(slotProps.data)"
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <Dialog
      :visible.sync="JobTitlesForm"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Job Titles"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col relative">
          <label for="noteHeader">Display Order:</label>
          <InputText
            id="noteHeader"
            v-model.trim="JobTitle.jobTitleCode"
            required="true"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteDetails">Description:</label>
          <InputText
            placeholder=""
            :disabled="false"
            :autoResize="true"
            rows="6"
            v-model="JobTitle.jobTitleDesc"
          />
        </div>
        <div class="p-field p-col">
          <label for="noteDetails">Active:</label>
          <SelectButton
            v-model="JobTitle.active"
            :options="options"
            optionLabel="label"
            optionValue="value"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="JobTitlesForm = false"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
      </template>
    </Dialog>
    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Do you wish to delete the Job Titles?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deleteJobTitle"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { settingFormReady } from "./settingsForm";
import CustomerService from "@/service/CustomerService";
import PermissionMixin from "../PermissionMixin.vue";
export default {
  mixins: [PermissionMixin],
  customerService: null,
  data: () => ({
    JobTitlesForm: false,
    displayConfirmation: false,
    loading: true,
    filters: {},
    JobTitles: null,
    JobTitle: {},
    options: [
      { value: true, label: "yes" },
      { value: false, label: "no" }
    ]
  }),
  methods: {
    getButtons(data) {
      this.checkPermissions();
      let buttons = [];
      if (this.deleteSettings) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.openConfirmation(data);
          }
        });
      }
      return buttons;
    },
    openNewTypesForm() {
      this.JobTitle = { active: true };
      this.JobTitlesForm = true;
    },
    openConfirmation(data) {
      this.JobTitle = data;
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    editJobTitles(data) {
      this.JobTitle = { ...data }; // SAL: edit a copy, not the list row
      this.JobTitlesForm = true;
    },
    async deleteJobTitle() {
      this.closeConfirmation();
      await this.customerService.deleteJobTitles(this.JobTitle.id);
      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Job title removed",
        life: 5000
      });
      this.getAllJobTitles();
      this.getAllActiveJobTitlesByHard();
    },
    save() {
      if (!settingFormReady(this, this.JobTitle, "jobTitleDesc", "Description", "active")) return;
      if (!this.JobTitle.id) {
        this.customerService
          .postJobTitles(this.JobTitle)
          .then(res => {
            this.JobTitlesForm = false;
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Job title added",
              life: 5000
            });
            this.getAllJobTitles();
            this.getAllActiveJobTitlesByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving job title",
              life: 5000
            });
          });
      } else {
        this.customerService
          .putJobTitles(this.JobTitle, this.JobTitle.id)
          .then(res => {
            this.JobTitlesForm = false;
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Job title updated",
              life: 5000
            });
            this.getAllJobTitles();
            this.getAllActiveJobTitlesByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating job title",
              life: 5000
            });
          });
      }
    },
    getAllJobTitles() {
      this.loading = true;

      this.customerService
        .getAllJobTitlesByHard()
        .then(data => {
          this.JobTitles = data;
          this.loading = false;
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting job titles",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "jobtitles"'
          });
        });
    },
    getAllActiveJobTitlesByHard() {
      this.customerService
        .getAllActiveJobTitlesByHard()
        .then(data => {})
        .catch(err => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeJobTitles"'
          });
        });
    }
  },
  created() {
    this.customerService = new CustomerService();
  },
  mounted() {
    this.getAllJobTitles();
  }
};
</script>
